<template>
    <v-btn v-if="!isGuest"
           @click="syncImageState(currentFile)"
           :disabled="currentFile.type !== 'image' || isFileUploading(currentFile) || !canSyncImageState || blockLoading"
           v-tippy
           content="Sync Now"
    >
        <v-icon class="material-icons">mdi-sync</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile']),
        ...mapState("UI", ['startTips', 'showAddMatchTooltip']),
        ...mapGetters('User', ['isGuest']),
    },
    methods: {
        // TODO move to store
        isFileUploading(file) {
            if (file.status !== "uploaded") return true;
            else return false;
        },

        async syncImageState(file) {
            this.$store.dispatch("Loader/showProgressBar", "indeterminate");
            await window.imagesStateStore.removeItem(file.id);
            await window.lutify.applyLastState(file.id);
            setTimeout(() => {
                this.$store.dispatch("Loader/showProgressBar", false);
            }, 750);
        },
    }
}
</script>